import { useSelector } from 'react-redux';
import { Features, Flag } from '../model/Feature';
import { RootState } from '../../../app';

export const useFeatureFlag = <F extends Flag>(flag: F): Features[F] | undefined => {
  return useSelector((state: RootState) => state.featureFlags.flags[flag]);
};
